/**
 * border-us slug — create-form input schema and Mantine form helpers.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */
import { z } from "zod";

import {
  type BorderUsDocumentInput,
  BorderUsDocumentInputSchema,
  BorderUsLineItemInputSchema,
} from "~/shared/documents/schemas/border-us-input.schema";

export {
  type BorderUsDocumentInput,
  BorderUsDocumentInputSchema,
  BorderUsLineItemInputSchema,
} from "~/shared/documents/schemas/border-us-input.schema";

const BorderUsDocumentFieldsSchema = BorderUsDocumentInputSchema.omit({ orderId: true }).extend({
  lineItems: z.array(BorderUsLineItemInputSchema),
});

/** Mantine shell before prefill loads; lineItems stay empty until server prefill returns. */
export const borderUsDocumentFormInitialValues = (): Omit<BorderUsDocumentInput, "orderId"> =>
  BorderUsDocumentFieldsSchema.parse({ lineItems: [] });
